import styled from 'styled-components';
import React,{ useLayoutEffect,useState } from 'react';

const Navbar = () => {

    const [classes,setClasses] = useState("");
    const [isDisplay,setIsDisplay] = useState("no-display");
    const [navShow, setNavShow] = useState(false);


    useLayoutEffect( () => {
        const handleScroll = () => {
            const sticky = window.scrollY >= window.innerHeight;
            sticky ? setClasses("sticky") : setClasses("");
                sticky ? setIsDisplay("display") : setIsDisplay("no-display")
        }

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    },[isDisplay])

    const scrollTop =() => {
        window.scrollTo(0,0)
    }

    const showNav = () => {
        setNavShow(!navShow);
    }

    return(
            <Nav className={classes}>
                <button
                className={`navigation ${isDisplay}`}
                onClick={scrollTop}
                >
                    <i className="fas fa-arrow-up"/>
                </button>
                <main>
                <div className="l-navbar">
                    <a
                    className="l-pages"
                    href="/"
                    >
                        Home
                    </a>
                    <a
                    className="l-pages"
                    href="/#services"
                    >
                        Services
                    </a>
                    <a
                    className="l-pages"
                    href="/#journey"
                    >
                        Journey
                    </a>
                    <a className="l-pages"
                    href="/#products"
                    >
                        Products
                    </a>
                    <a
                    className="l-pages"
                    href="/#contact"
                    >
                        Contact
                    </a>
                    <a
                    className="l-pages"
                    href="/gallery"
                    >
                        Gallery
                    </a>
                    <a
                    className="l-pages"
                    href="/gallery/#categories"
                    >
                        categories
                    </a>
                </div>
                    <img src="/images/logo3.png" alt="Brand Logo" className={isDisplay}/>
                    <div className="hover" onClick={showNav}>
                        <i className="fas fa-bars"></i>
                    </div>
                </main>
                <div
                className={navShow ? "nav-screen dis-nav" : "nav-screen"}
                onClick={showNav}
                >
                </div>
                <nav
                className={navShow ? "nav dis-nav" : "nav"}
                >
                    <div
                    onClick={showNav}
                    >
                        <i className="fas fa-times"></i>
                    </div>
                    <div className="social-media">
                        <a target="_blank" rel="noreferrer" href="https://www.facebook.com/profile.php?id=100070448594548">
                            <div>
                                <i className="fab fa-facebook-f"></i>
                            </div>
                        </a>
                        <a target="_blank" rel="noreferrer" href="https://www.instagram.com/eroderoyal">
                            <div>
                                <i className="fab fa-instagram"></i>
                            </div>
                        </a>
                        <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/erode-royal-stainless-steels-516301217">
                            <div>
                                <i className="fab fa-linkedin-in"></i>
                            </div>
                        </a>
                        <a target="_blank" rel="noreferrer" href="tel:+918610118450">
                            <div>
                                <i className="fas fa-phone"></i>
                            </div>
                        </a>
                    </div>
                    <a
                    onClick={showNav}
                    className="pages"
                    href="/"
                    >
                        Home
                    </a>
                    <a
                    className="pages"
                    href="/#services"
                    onClick={showNav}
                    >
                        Services
                    </a>
                    <a
                    className="pages"
                    href="/#journey"
                    onClick={showNav}
                    >
                        Journey
                    </a>
                    <a className="pages"
                    href="/#products"
                    onClick={showNav}
                    >
                        Products
                    </a>
                    <a
                    className="pages"
                    href="/#contact"
                    onClick={showNav}
                    >
                        Contact
                    </a>
                    <a
                    className="pages"
                    href="/gallery"
                    onClick={showNav}
                    >
                        Gallery
                    </a>
                    <a
                    className="pages"
                    href="/gallery/#categories"
                    onClick={showNav}
                    >
                        categories
                    </a>
                </nav>
            </Nav>
    )
}

const Nav  = styled.div`
    width: 100%;
    z-index: 5;
    main {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        min-height: 65px;
        background: rgba(0,0,0,0.7);
    }
    .nav-screen {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 120vh;
        background: rgba(0,0,0,0.5);
        transform: translateX(-100%);
        transition: transform 0.3s ease-in;
    }
    nav {
        width: 80%;
        max-width: 300px;
        height: 120vh;
        position: fixed;
        top: 0;
        right: 0;
        background: #000;
        z-index: 8;
        transform: translateX(100%);
        transition: transform 0.3s ease-in;
    }
    .fa-times {
        position: absolute;
        top: 2rem;
        right: 2rem;
    }
    .social-media a {
        display: inline-block;
        margin-left: 2.5rem;
        margin-top: 8rem
    }
    a.pages {
        font-weight: 500;
        text-decoration: none;
        display: block;
        margin: 0 2.5rem 1.5rem 2.5rem;
    }
    a.pages:focus, a.pages:hover, a.pages:active {
        color: #f9ea17;
    }
    nav a:nth-child(3) {
        margin-top: 2.5rem;
    }
    .dis-nav {
        transform: translateX(0);
    }
    h1 {
        font-weight: 900;
        margin: 0 1rem;
    }
    .hover {
        position: absolute;
        right: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 42px;
        height: 42px;
        border-radius: 50%;
    }
    .hover:hover {
        background: #353535;
    }
    .l-navbar {
        display: none;
    }
    i {
        color: #fff;
        font-size: 1.5rem;
    }
    img {
        width: 30px;
        height: 35px;
        margin-left: 2rem;
    }
    .no-display {
        display: none;
    }
    .display {
        display: block;
    }
    .navigation{
        background: #000;
        width: 50px;
        height: 50px;
        border: none;
        border-radius: 50%;
        position: fixed;
        right: 30px;
        bottom: 30px;
        z-index: 5;
        box-shadow: 4px -3px 4px #585858;
    }
    .navigation:active {
        transform: translate3d(4px,-3px,0)
    }
    @media screen and (min-width: 1000px) {
        .hover,.display {
            display: none;
        }
        a.l-pages:focus, a.l-pages:hover, a.l-pages:active {
        color: #f9ea17;
        }
        .l-navbar {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%
        }
        a.l-pages {
        font-weight: 500;
        text-decoration: none;
        margin-left: 2.5rem;
        font-size: 1.2rem;
        }
        a.l-pages:nth-child(1) {
            margin-left: 0;
        }
    }
    `;
    
export default React.memo(Navbar);